import React from 'react'

import HSGCard from '../../../../Components/HSGCard/HSGCard'

import '../SmartClinic.css'

class EpisodeStats extends React.Component{

    constructor(props){
        super(props)
        this.state = {}
    }

    componentWillMount() {
        this.props.fetchEpisodeStats(this.props.organizationId)
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    getValueInputDivision = (className, label, input, defaultInput, index) => (
        input || defaultInput ?
        <div className={className} key = {index}>
            <label className = "hsg-sv-label">{label}</label>
            <label className = "hsg-sv-input">{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    getComplainNodesValueInputDivision = (className, labelClass, inputClass, label, input, defaultInput, index) => (
        input || defaultInput ?
        <div className={className} key = {index}>
            <label className = {`${labelClass} hsg-sv-label`}>{label}</label>
            <label className = {`${inputClass} hsg-sv-input`}>{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    getSingleValueInputHeaderDivision = (label, input) => (
        <div>
            <label className = "col-md-12 col-sm-12 col-xs-12 padding-5 hsg-sv-label center">{label}</label>
            <label className = "col-md-12 col-sm-12 col-xs-12 padding-5 hsg-sv-input center">{`${input}`}</label>
        </div>
    )

    getSingleStatsCard = (className, label, input) => (
        <div className = {className}>
            <HSGCard hideHeader>
                <div className="hsg-card-details row">
                    {this.getSingleValueInputHeaderDivision(label, input)}
                </div>
            </HSGCard>
        </div>
    )

    _renderStatsHeader = (stats) => (
        <div style ={{marginTop: 20}}>
            {this.getSingleStatsCard("col-lg-4 col-md-4 col-sm-6 col-xs-6 padding-10", 'Till Date', stats.all_episodes)}
            {this.getSingleStatsCard("col-lg-4 col-md-4 col-sm-6 col-xs-6 padding-10", 'This Month', stats.monthly_episodes)}
            {this.getSingleStatsCard("col-lg-4 col-md-4 col-sm-6 col-xs-6 padding-10", 'This Week', stats.weekly_episodes)}
        </div>
    )

    _renderDailyReportComplainNodes = (className, complaint, header) => (
        <div className = {className}>  
            <div className="col-md-12 col-sm-12 col-xs-12">
                <label className = "hsg-sv-label">{header}</label>
            </div>      
            <div className="col-md-12 col-sm-12 col-xs-12">
                {
                    complaint ? complaint.map((data, index) => (
                        this.getComplainNodesValueInputDivision(
                            'col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-10', 
                            'col-lg-10 col-md-10 col-sm-10 col-xs-10 padding-0', 
                            'col-lg-2 col-md-2 col-sm-2 col-xs-2 padding-2', 
                            data.node, data.count, null, index
                        )
                    )) : 'No Data Available'
                }
            </div>
        </div>
    )

    _renderDailyReport = (report) => (
        <HSGCard headingLeft = {'Daily Report'}>
            <div className="hsg-card-details row">
                <div className="row col-md-12 col-sm-12 col-xs-12 padding-10">     
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className = "hsg-sv-input">{'Over All'}</label>
                    </div>         
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">  
        
                        {this.getValueInputDivision("row col-lg-6 col-md-6 col-sm-12 col-xs-12", 'Student Visited: ', report.students, '0')}
                        {this.getValueInputDivision("row col-lg-6 col-md-6 col-sm-12 col-xs-12", 'Episode Completed: ', report.episodes, '0')}

                    </div>
                </div>
                <div className="row col-md-12 col-sm-12 col-xs-12 padding-10">     
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <label className = "hsg-sv-input">{'Complaint Stats'}</label>
                    </div>         
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">  

                        {this._renderDailyReportComplainNodes("col-lg-4 col-md-4 col-sm-12 col-xs-12 padding-5", report.complaints, 'Top 3 Complaints')}
                        {this._renderDailyReportComplainNodes("col-lg-4 col-md-4 col-sm-12 col-xs-12 padding-5", report.symptoms, 'Top 3 Symptoms')}
                        {this._renderDailyReportComplainNodes("col-lg-4 col-md-4 col-sm-12 col-xs-12 padding-5", report.suggestions, 'Top 3 Treatment')}

                    </div>
                </div>
            </div>
        </HSGCard>
    )

    _renderStatsBody = (stats) => (
        <div>
            {this._renderDailyReport(stats)}
        </div>
    )

    render(){

        let {stats} = this.props

        return (
            <div className = "container" style ={{marginTop: 20}}>
                
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10">
                    {stats && this._renderStatsHeader(stats)}
                </div>
                
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10" style ={{marginTop: 20}}>
                    {stats.daily_report && this._renderStatsBody(stats.daily_report)}
                </div>

            </div>
        )
    }
}

export default EpisodeStats


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/EpisodeStats/EpisodeStats.js